// Mobile menu toggle
const mobileMenuBtn = document.getElementById('mobile-menu-btn')
const mobileMenu    = document.getElementById('mobile-menu')
const menuIcon      = document.getElementById('menu-open-icon')
const closeIcon     = document.getElementById('menu-close-icon')

if (mobileMenuBtn && mobileMenu) {
  mobileMenuBtn.addEventListener('click', () => {
    const isOpen = !mobileMenu.classList.contains('hidden')
    mobileMenu.classList.toggle('hidden')
    menuIcon?.classList.toggle('hidden', !isOpen)
    closeIcon?.classList.toggle('hidden', isOpen)
    mobileMenuBtn.setAttribute('aria-expanded', String(!isOpen))
  })
}

// Nav shadow on scroll
const nav = document.querySelector('nav')
if (nav) {
  const onScroll = () =>
    nav.classList.toggle('shadow-stone-950/60', window.scrollY > 8)
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
}

// Intersection-observer entrance animation (add data-animate to any element)
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('opacity-0', 'translate-y-4')
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.08 },
  )

  document.querySelectorAll('[data-animate]').forEach((el) => {
    el.classList.add(
      'opacity-0', 'translate-y-4',
      'transition-all', 'duration-500', 'ease-out',
    )
    observer.observe(el)
  })
}
